import axios from 'axios'
import { handleSessionExpired } from '../utility/sessionExpired'

/**
 * Interceptor global: como todos los servicios importan la misma instancia
 * por defecto de axios, basta registrarlo una vez (ver src/index.js) para
 * que aplique a cualquier petición hecha con `import axios from 'axios'`.
 * Si el backend responde 401 (token vencido o inválido) se cierra la
 * sesión local y se redirige al login.
 */
axios.interceptors.response.use(
    response => response,
    error => {
        if (error?.response?.status === 401 && sessionStorage.getItem('token')) {
            handleSessionExpired()
        }
        return Promise.reject(error)
    }
)
